<div class="page-wrapper">
  <ng-container>
    <div class="container">
      <div class="dashboard-header">
        <ng-container *ngTemplateOutlet="headerContents"></ng-container>
      </div>
      <ng-template #headerContents>
        <div class="dashboard-header__contents">
          @if (userName) {
            <h2 class="fw-bold">Welcome {{ userName }} to CSV Dashboard page</h2>
          }
          <div class="dashboard-header__tools">
            <div class="dashboard-header-tools__date">
              <img class="icon-calendar" src="assets/icons/calendar.svg" alt="Icon Calendar">
              <p>{{date}}</p>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="widget-row mt-4">
        <ng-container *ngTemplateOutlet="csvFileDashboard"></ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #csvFileDashboard>
    <ng-container>
      <app-csv-dashboard-widget data-test-id="app-dashboard-e-csv-dashboard-widget"></app-csv-dashboard-widget>
    </ng-container>
  </ng-template>
</div>
